import { CrudModel } from './_crud';

export class CompanyModel extends CrudModel {
	constructor() {
		super('admin/company');
	}

	async sapSync(data: any) {
		//console.log('custom action', data);
		try {
			//const endpoint = 'admin/company/sap-sync';
			return (await this.post(null, 'sap-sync', { })); // await before return allows error catching
		} catch (error) {
			await super.handleError(error);
		}
	}
}

export default new CompanyModel();
